export default __webpack_public_path__ + "static/media/ic_imageupload.d115467f.svg";